export function setMobileMapView() {
  return window.setView?.("map");
}
